import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { connect, ConnectedProps } from 'react-redux'

import { IProtocol, IProtocolsTableState } from '../../shared/interfaces';

import { ITag, IBasePicker} from '@fluentui/react';
import { reduxActions, RootState } from '../../store';

import { RoleContext} from '../../shared/enums';


import { checkRoles } from '../../hoc/CheckRoles';
import { CancelTokenSource } from 'axios';
import { AppNavigationState } from '../../store/app-navigation/types';
import SearchKQLComponentBase from './SearchKQLComponentBase';





const mapState = (state: RootState) => ({
    currentUser: state.sessionReducer.currentUser,
    currentAoo: state.sessionReducer.currentAoo,
    allRoles: state.sessionReducer.allRoles,
    features: state.sessionReducer.features,
    protocolsTableState: state.appNavigationReducer.protocolsTableState
})

const mapDispatch = {
    setProtocolsTableState: (protocolsTableState: (Partial<IProtocolsTableState>)) => (reduxActions.appNavigationActions.setProtocolsTableState(protocolsTableState)),
    unsetProtocolsTableState: () => (reduxActions.appNavigationActions.unsetProtocolsTableState()),
    updateAppNavigationState: (state: AppNavigationState) => (reduxActions.appNavigationActions.updateAppNavigationState(state))
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface SearchPageState {
}
export interface SearchPageProps {
}

type Props = SearchPageProps & RouteComponentProps & PropsFromRedux

class SearchPage extends React.Component<Props, SearchPageState> {
    tagPickerRef = React.createRef<IBasePicker<ITag>>();
    cancelTokenSources = {};

    constructor(props) {
        super(props);
        this.state = {
        
        };
    }


    componentWillUnmount() {
        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
        this.saveScrollPosition();
    }

    saveState = (protocolsTableState) => {

        this.props.setProtocolsTableState({ ...protocolsTableState})
    }


    saveScrollPosition = () => {

        const el = document.getElementById('scroll');
        const scrollPanel = el?.querySelectorAll(".p-scrollpanel-content")[0];
        let scrollTop = scrollPanel?.scrollTop;


        this.props.setProtocolsTableState({ scrollTop: scrollTop! })
    }





 
    

    onSearchBaseWillUnmount = () => {
        this.saveScrollPosition();
    }



    public render() {

        return (
            <SearchKQLComponentBase
                protocolsTableState={this.props.protocolsTableState}
                updateProtocolsTableState={this.saveState}
                searchBaseWillUnmount={this.onSearchBaseWillUnmount}

            />

        );
    }

}



export default connector(withRouter(checkRoles(SearchPage, RoleContext.Aoo)));




